<template src="./ListDocumentPlan.html"></template>

<script>
import { getAllTemplatesDocumentPlan } from "../../../services";

export default {
  name: "ListDocumentPlan",
  data() {
    return {
      plans: [],
    };
  },
  created() {
    this.getPlansDocument();
  },

  methods: {
    async getPlansDocument() {
      try {
        this.plans = await getAllTemplatesDocumentPlan();
      } catch (err) {
        console.log("Error on get templates plans:", err);
      }
    },
  },
};
</script>
